
import Main from './components/layout/Main';
import Login from './components/auth/Login';
import { Box, CircularProgress, NoSsr, ThemeProvider, Typography } from '@mui/material';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Notification from './components/layout/Notification';
import theme from './theme';
// import NotFound from './components/auth/NotFound';
import { PrivacyPolicy } from './components/layout/PrivacyPolicy';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails, logout } from './actions/auth';
import IdleTimeoutHandler from './components/auth/IdleTimeoutHandler';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(state => state.auth);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      // No token at all – treat as unauthenticated
      setAuthChecked(true);
      return;
    }

    // Validate the token once on app load
    const validate = async () => {
      try {
        await dispatch(getUserDetails());
      } catch (error) {
        // If the call fails (e.g. 401), clear token and mark as unauthenticated
        localStorage.removeItem('token');
        dispatch(logout());
      } finally {
        setAuthChecked(true);
      }
    };

    validate();
  }, []);

  { console.log(isAuthenticated, authChecked) }
  if (!authChecked) {
    return (
      <NoSsr>
        <ThemeProvider theme={theme}>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <CircularProgress />
            <Typography variant='h6'>Loading...</Typography>
          </Box>
        </ThemeProvider>
      </NoSsr>
    );
  }

  return (
    <NoSsr>
      <ThemeProvider theme={theme}>
        <Router>
          <Box >
            <Notification />
            {isAuthenticated ? (
              <>
                <IdleTimeoutHandler />
                <Routes>
                  <Route path='/'>
                    <Route index element={<Navigate to='/home' replace />} />
                    <Route path=':page' element={<Main />} />
                    <Route path='project/:projectId' element={<Main />} />
                  </Route>
                  <Route path='/login' element={<Navigate to='/home' replace />} />
                  <Route path='*' element={<Navigate to='/home' replace />} />
                </Routes>
              </>
            ) : (
              <Routes>
                <Route path='/' element={<Login />} />
                <Route path='/login' element={<Login />} />
                <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                <Route path='*' element={<Navigate to='/login' replace />} />
              </Routes>
            )}
          </Box>
        </Router>
      </ThemeProvider>
    </NoSsr >
  );
}

export default App;
